import React from "react";

import { FileRecordStatus } from "../../../../../../common/types/FileRecordStatus";
import { RejectMultipleFileRecordsDialog } from "../../../reject/RejectMultipleFileRecordsStatusDialog";
import { ChangeMultipleFileRecordsToWaitingForResponseDialog } from "../../change-to-waiting-for-client-response/ChangeMultipleFileRecordsToWaitingForResponseDialog";
import { UpdateMultipleFileRecordsStatusDialog } from "./UpdateMultipleFileRecordsStatusDialog";

interface UpdateMultipleFileRecordStatusDialogManagerProps {
    status?: FileRecordStatus;
    isOpen: boolean;
    onDismiss: () => void;
}

export const UpdateMultipleFileRecordStatusDialogManager: React.VFC<UpdateMultipleFileRecordStatusDialogManagerProps> = ({
    status,
    isOpen,
    onDismiss
}: UpdateMultipleFileRecordStatusDialogManagerProps) => {
    switch (status) {
        case FileRecordStatus.Rejected:
            return <RejectMultipleFileRecordsDialog onClose={onDismiss} />;
        case FileRecordStatus.WaitingForClientResponse:
            return <ChangeMultipleFileRecordsToWaitingForResponseDialog onClose={onDismiss} />;
        case FileRecordStatus.Editing:
        case FileRecordStatus.Qc:
        case FileRecordStatus.QcDone:
        case FileRecordStatus.Destroyed:
            return (
                <UpdateMultipleFileRecordsStatusDialog isOpen={isOpen} onClose={onDismiss} selectedStatus={status} />
            );

        default:
            return <></>;
    }
};
